import { ApiPaths } from "../../api/ApiPaths";
import { NotificationEmail } from "../../../domain/user/notification/NotificationEmail";
import { ApiRequest } from "../../api/ApiRequest";

export type GetNotificationEmailSuccessResponseType = {
    notifications: [{
        email: string
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getNotificationEmail(): Promise<GetNotificationEmailSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.user.notificationEmail,
        {},
        () => {},
        () => {});
}

export async function updateNotificationEmail(notifications: NotificationEmail[]) {
    const body = {
        notifications: notifications.map(notification => (
            { email: notification.value }
        ))
    };
    return await ApiRequest.post(
        ApiPaths.user.notificationEmail,
        {},
        body,
        () => {},
        () => {});
}
